import { Link } from "react-router-dom";
import styled from "styled-components";
import { themeVariables } from "src/themeVariables";

const AccessBanner = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  border: 1px solid ${themeVariables.grey3};
  border-radius: 14px;
  background: ${themeVariables.menuColor};
  color: ${themeVariables.grey0};
  font-family: "Inter";
  font-size: 16px;
  line-height: 1.5;

  a {
    color: ${themeVariables.primaryCTA};
  }
`;

function DraftProseAccessGate({ blocked, children }) {
  if (!blocked) return <>{children}</>;

  return (
    <AccessBanner aria-label="Draft subscription required">
      This isn't available on your free trial. <Link to="/app/plans?ref=prose-gen">Subscribe to Sudowrite</Link>.
    </AccessBanner>
  );
}

export default DraftProseAccessGate;
